



















export default {
    name: 'prize-item',
    props: {
        image: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        quantity: {
            type: Number,
            default: 0,
        },
        order: {
            type: Number,
            default: 1,
        },
        automationText: {
            type: String,
            default: 'prize-item',
        },
    },
};
